const INCOME_SOURCE_MAP = {
    "full time work": "full_time",
    "part time work": "part_time",
    "casual work": "casual",
    "self employed": "self_employed_contract",
    "jobseeker": "unemployment_benefits",
    "jobkeeper": "unemployment_benefits",
    "centrelink": "unemployment_benefits",
    "other": "other_benefits"
};

const LOAN_REASON_MAP = {
    "medical/ dental costs": "medical_dental_bill",
    "household bills": "utilities_bill",
    "vet costs": "vet_bill",
    "consolidate debt": "debt_consolidation",
    "emergency funds": "emergency",
    "education for children, training for me": "school_education",
    "home renovations": "home_improvements_repair",
    "furniture appliances": "appliance_purchase",
    "bond loan": "rental_bond_cleaning",
    "purchase a vehicle": "car_purchase",
    "car repairs": "vehicle_repairs",
    "wedding expenses": "wedding",
    "funeral expenses": "funeral",
    "travel holiday": "holiday_travel",
    "cosmetic costs": "lifestyle_other"
};

export const convertAppIncomeSourceToLeadMarketIncomeSource = (appFormIncomeSource) => {
    return INCOME_SOURCE_MAP[appFormIncomeSource.toLowerCase()] || "";
};

export const convertAppFormLoanReasonToLeadMarketLoanReason  = (appformLoanReason) => {
    return LOAN_REASON_MAP[appformLoanReason.toLowerCase()] || "";
}
